module.exports = __webpack_public_path__ + "static/media/angle-right-white.94f444d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/angle-right-white.svg
// module id = 469
// module chunks = 2